module.exports = __webpack_public_path__ + "img/equipeSirius.834a8225.png";